import React, { FC, useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { LEFT_PACKAGES_COUNT } from "../../graphql/queries";
import "./styles.scss";

const Countdown: FC<any> = (): JSX.Element => {
  // const { data: packages, loading, refetch } = useQuery(LEFT_PACKAGES_COUNT);

  // timer
  const calculateTimeLeft = () => {
    const difference =
      +new Date("Nov 4 2021 07:00:00 GMT") -
      +new Date(new Date().toUTCString());
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  }, []);
  //timer

  return (
    <div className="p-wrapper">
      <p className='text-center'>Don't miss out, our special lifetime deal ends in:</p>
      <div className="countdown_container">
      <div className="unit">
          <div className="number_container">
            {
              //@ts-ignore
              timeLeft.days
            }
          </div>
          <div className="label_container">Days</div>
        </div>
        <div className="unit">
          <div className="number_container">
            {
              //@ts-ignore
              timeLeft.hours
            }
          </div>
          <div className="label_container">Hours</div>
        </div>
        <div className="unit">
          <div className="number_container">
            {
              //@ts-ignore
              timeLeft.minutes
            }
          </div>
          <div className="label_container">Minutes</div>
        </div>
        <div className="unit">
          <div className="number_container">
            {
              //@ts-ignore
              timeLeft.seconds
            }
          </div>
          <div className="label_container">Seconds</div>
        </div>
        {/* {packages &&
          packages.User &&
          packages.User.getHexomateLeftLTDPackagesCount && (
            <div
              className="unit packages d-none d-sm-block"
              style={{ width: "100%" }}
            >
              <div className="number_container">
                {packages.User.getHexomateLeftLTDPackagesCount.count > 0
                  ? packages.User.getHexomateLeftLTDPackagesCount.count
                  : 0}
              </div>
              <div className="label_container">Seats Left</div>
            </div>
          )} */}
      </div>
{/* 
      {!loading && packages.User.getHexomateLeftLTDPackagesCount &&
        !packages.User.getHexomateLeftLTDPackagesCount.error && (
          <p className="text-center f_size_22">
            <strong>
              {packages.User.getHexomateLeftLTDPackagesCount.count > 0
                ? packages.User.getHexomateLeftLTDPackagesCount.count
                : 0}
            </strong>{" "}
            early bird seats left
          </p>
        )} */}
    </div>
  );
};

export default Countdown;
